













































































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'VenueCard'

  vue:
    props: ['item', 'options']

    components: {
      LoadingIndicator,
    }

    data: ->
      mapOptions:
        draggable: true
        zoomControl: false
        mapTypeControl: false
        mapTypeId: 'satellite'
        tilt: 0
        scaleControl: false
        streetViewControl: false
        rotateControl: false
        fullscreenControl: false
        disableDefaultUi: true

    computed:
      mapPolygonOptions: ->
        strokeColor: '#13A7C1'
        strokeOpacity: 0.8
        strokeWeight: 2
        fillColor: '#13A7C1'
        fillOpacity: 0.35

      mapPlaceholderPolygonOptions: ->
        strokeColor: '#3d4852'
        strokeOpacity: 0.6
        strokeWeight: 2
        fillColor: '#3d4852'
        fillOpacity: 0.3

      editable: ->
        return @options.editable if @options?.editable?
        true

      location: ->
        @$options.filters.formatLocation @item

      country: ->
        return '' unless @item.country
        return 'US' if @item.country.toLowerCase() in ['us', 'united states']
        @item.country.slice(0, 2).toUpperCase()

      tags: ->
        { formatTitle } = @$options.filters
        tags = []
        tags.push { value: @item.venue_type, label: formatTitle(@item.venue_type) } if @item.venue_type
        tags

      zoom: -> 18
      lat: -> @item.geo_coordinates?[1]
      lng: -> @item.geo_coordinates?[0]
      showMap: -> @item.venue_class is 'venue' and @lat and @lng
      polygon: -> @item.geo_polygons?[0]?.coordinates
      isGeofenceTrusted: -> !!@item.geo_fence_trusted

    methods:
      hiNavToDetails: (listing) ->
        @$router.push { name: 'VenueShowPage', params: { venueId: @item.id } }

export default VueOptions.vue settings
